export default __webpack_public_path__ + "static/media/React-icon.add74742.svg";